import { Button } from '~/components/ui/button'

// 하단 반영 액션바. 선택 건수(수정·추가)를 요약하고 "선택 N건 반영"으로
// 일괄 반영을 요청한다(실제 확인·호출은 ConfirmDialog·훅이 처리).
export function DiffActions({
    applyCount,
    modifiedCount,
    addedCount,
    applying,
    onApply,
}: {
    applyCount: number
    modifiedCount: number
    addedCount: number
    applying: boolean
    onApply: () => void
}) {
    return (
        <div className='border-border flex items-center justify-between gap-3 border-t p-4'>
            <span className='text-muted-foreground text-sm'>
                {applyCount > 0
                    ? `선택 ${applyCount}건 (수정 ${modifiedCount} · 추가 ${addedCount})`
                    : '반영할 추가·수정 항목을 선택하세요.'}
            </span>
            <Button
                size='sm'
                disabled={applyCount === 0 || applying}
                onClick={onApply}>
                {applying ? '반영 중…' : `선택 ${applyCount}건 반영`}
            </Button>
        </div>
    )
}
